// _services/galleryService.js
import api from '../../../api/axios';

export const galleryService = {
  /**
   * Obtener galería del template
   */
  getGallery: async (slug) => {
    const response = await api.get(`/admin/template/${slug}`);
    return response.data.gallery || [];
  },

  /**
   * Subir imágenes a la galería
   */
  uploadImages: async (slug, files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("images", file));

    const token = localStorage.getItem("token");
    const response = await api.put(`/admin/template/${slug}/gallery`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  /**
   * Validar archivos de imagen
   */
  validateFiles: (files) => {
    const validFiles = files.filter(
      file => file.type.startsWith('image/') && file.size <= 5 * 1024 * 1024
    );
    return {
      valid: validFiles,
      invalid: files.filter(
        file => !file.type.startsWith('image/') || file.size > 5 * 1024 * 1024
      ),
      error: validFiles.length === 0 ? 'No hay imágenes válidas (máximo 5MB por imagen)' : null
    };
  },

  /**
   * Crear URLs de preview
   */
  createPreviews: (files) => {
    return files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
  },

  /**
   * Limpiar URLs de preview
   */
  revokePreviews: (previews) => {
    previews.forEach(preview => URL.revokeObjectURL(preview.preview));
  }
};